import {
	lengthConversions,
	pressureConversions,
	flowConversions,
	volumeConversions,
	velocityConversions,
	areaConversions,
} from './unitClassification';
import { SYSTEM_UNIT_TYPE, UNITS } from './unitsMappingValues';

export const unitMapping = (fieldUnitType: string): string => {
	switch (fieldUnitType) {
		case SYSTEM_UNIT_TYPE.LENGTH_LONG:
			return UNITS.METER;
		case SYSTEM_UNIT_TYPE.LENGTH:
			return UNITS.MILLIMETER;
		case SYSTEM_UNIT_TYPE.VOLUME:
			return UNITS.CUBIC_METER;
		case SYSTEM_UNIT_TYPE.PRESSURE:
			return UNITS.METER_OF_HEAD;
		case SYSTEM_UNIT_TYPE.FLOW:
			return UNITS.CUBIC_METER_PER_SECOND;
		case SYSTEM_UNIT_TYPE.ANGLE:
			return UNITS.DEGREE;
		case SYSTEM_UNIT_TYPE.AREA:
			return UNITS.METER_SQUARE;
		case SYSTEM_UNIT_TYPE.POWER:
			return UNITS.KILO_WATT;
		case SYSTEM_UNIT_TYPE.VELOCITY:
			return UNITS.METER_PER_SECOND;
		default:
			return UNITS.MILLIMETER;
	}
};

/**
 * Convert a numeric value from one unit to another
 * @param value - The numeric value to convert
 * @param fromUnit - The source unit (e.g., 'mm')
 * @param toUnit - The target unit (e.g., 'm')
 * @returns The converted value, or the original value if conversion is not possible
 *
 * @example
 * convertValue(100, 'mm', 'm') // returns 0.1
 * convertValue(0.1, 'm', 'mm') // returns 100
 * convertValue(5, 'l/s', 'm3/s') // returns 0.005
 * convertValue(10, 'psi', 'mH2O') // returns 14.223...
 */
export const convertValue = (
	value: number,
	fromUnit: string,
	toUnit: string,
): number => {
	if (!fromUnit || !toUnit || fromUnit === toUnit) {
		return value;
	}

	// Try each conversion category
	const conversionMaps = [
		lengthConversions,
		pressureConversions,
		flowConversions,
		volumeConversions,
		velocityConversions,
		areaConversions,
	];

	for (const conversions of conversionMaps) {
		if (conversions[fromUnit] && conversions[toUnit]) {
			return (value * conversions[fromUnit]) / conversions[toUnit];
		}
	}

	// No conversion available, return original value
	return value;
};
